/* eslint-disable react/no-unused-prop-types */
import { KEY_CODES, openModalByName, useScopedSelector } from 'ia-react-core';
import React, { FC, useCallback, KeyboardEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { StyledP, StyledLink, StyledNoBreakWrapper } from '../DocumentsHeader.styles';
import { AvailableDocumentGroup } from '../../../interfaces/AvailableDocumentGroup';
import { DocumentGroup } from '../../../interfaces/DocumentGroup';

export interface DocumentsHeaderTextProps { }

const DocumentsHeaderText: FC<DocumentsHeaderTextProps> = () => {
  const { t } = useTranslation('Documents');
  const dispatch = useDispatch();
  const documentListData: DocumentGroup[] = useScopedSelector('/App.features.documents.list.groups');
  const documentAvailableData: AvailableDocumentGroup[] = useScopedSelector('/App.features.documents.available');

  const handleKeyDown = useCallback((event: KeyboardEvent) => {
    if (event?.keyCode === KEY_CODES.ENTER || event?.keyCode === KEY_CODES.SPACE) {
      dispatch(openModalByName('availableDocumentsModal'));
    }
  }, [dispatch]);

  if (!documentListData) {
    return null;
  }

  if (documentAvailableData && documentAvailableData.flatMap((x) => x.documents).length > 0) {
    return (
      <StyledP
        tabIndex={0}
        aria-label={t('description.ariaPLabel')}
        onKeyDown={handleKeyDown}
      >
        {t('description.part1')}{' '}
        <StyledNoBreakWrapper data-testid="documentsHeaderTextLink">
          <StyledLink
            aria-label={t('description.ariaLabel')}
            onClick={() => dispatch(openModalByName('availableDocumentsModal'))}
          >{t('description.part2')}
          </StyledLink>
        </StyledNoBreakWrapper>
        {' '}{t('description.part3')}
      </StyledP>
    );
  }

  return (<StyledP>{t('description.part1')}{' '}{t('description.part2')}{' '}{t('description.part3')}</StyledP>);
};

export default DocumentsHeaderText;
